jQuery( document ).ready(function($) {
  
   const cookieBox = document.querySelector(".wrapper"),
  buttons = document.querySelectorAll(".button");

const executeCodes = () => {
  //if cookie contains codinglab it will be returned and below of this code will not run
  if (document.cookie.includes("codinglab")) return;
  cookieBox.classList.add("show");

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      cookieBox.classList.remove("show");

      //if button has acceptBtn id
      if (button.id == "acceptBtn") {
        //set cookies for 1 month. 60 = 1 min, 60 = 1 hours, 24 = 1 day, 30 = 30 days
        document.cookie = "cookieBy= codinglab; max-age=" + 60 * 60 * 24 * 30;
      }
    });
  });
};

//executeCodes function will be called on webpage load
window.addEventListener("load", executeCodes);
  
  setTimeout(function() {
      $( ".event-gallery-section" ).fadeIn( "slow", function() {
        // Animation complete
      });
  }, 100);
  
   /* register account */ 
    $(function() {
      $('#students_from').hide(); 
      $('#parents_from').hide(); 
      $('#type').change(function(){
          if($('#type').val() == 'students') {
              $('#students_from').show(); 
              $('#parents_from').hide(); 
          } else {
              $('#students_from').hide(); 
              $('#parents_from').show(); 
          } 
      });
    });

    $(".toggle-password, .toggle-password1").click(function() {
        $(this).toggleClass("fa-eye fa-eye-slash");
        input = $(this).parent().find("input");
        if (input.attr("type") == "password") {
            input.attr("type", "text");
        } else {
            input.attr("type", "password");
        }
    });
    
  /* on hover show menu */

   let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
   
    items.forEach(item => {
      item.addEventListener("mouseover", () => {
        item.setAttribute("open", true);
        item.querySelector("ul").addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });
      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    });
    
    });  
  
   if ($(window).width() < 1202)
    {
      $('.custom--mneu__logo--header-section').hide();
      $('header-drawer').show();
      $(window).scroll(function() {    
       var scroll = $(window).scrollTop(); 
        if (scroll >= 100) { 
            $(".header-wrapper").addClass("fixedHeader");
           
        } else {
          $(".header-wrapper").removeClass("fixedHeader");
          
        }
      });
    } else { 
      $(window).scroll(function() {    
        var scroll = $(window).scrollTop(); 
        if (scroll >= 100) { 
            $(".custom--mneu__logo--header-section").addClass("fixedHeader"); 
        } else {
          $(".custom--mneu__logo--header-section").removeClass("fixedHeader"); 
        }
      });
    }
  
  /* home-banner-slider-js */
  
    $('.banner-left--slider').slick({
      infinite: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 2500,
      speed:1000,
      fade: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      pauseOnHover: false
    });
  
    $('.banner-right--slider').slick({
      infinite: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 2500,
      speed:1000,
      fade: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      pauseOnHover: false
    });
  
   /* home-our-focus-slider-js */

     $('.our-focus---slider').slick({
      infinite: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 1800,
       speed:500,
      arrows: false,
      slidesToShow: 4,
      slidesToScroll: 1,
       pauseOnHover: false,
      responsive: [
        {
          breakpoint: 1602,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1201,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });

   /* event-gallery-slider-js */

     $('.event-gallery-section ul').slick({
      infinite: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 1800,
       speed:500,
      arrows: false,
      slidesToShow: 4,
      slidesToScroll: 1,
       pauseOnHover: false,
      responsive: [
        {
          breakpoint: 1602,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1201,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
  
  /* tooltip js */

       $(document).ready(function(){
      tooltipObj.init();   
    });

var tooltipObj = {
    init: function(){
        this.events();
    },
    events: function(){
        var _this = this;
        $('[data-ui-tooltip]').on('mouseenter',function(e){
 
            var $el = $(this),
                text = $el.data("ui-tooltip");
            _this.mouseenterEvent(e, text, $el);
        });
 
        $('[data-ui-tooltip]').on('mouseleave click',function(e){
            _this.mouseleaveEvent(e);
        });
    },
    mouseenterEvent: function(e, text, $el){
 
        if(typeof text != 'undefined'){
 
            var tt      = $('.tooltipOuter').clone().addClass("temp"),
                ttCon   = $('.tooltipInner').clone(),
                offset  = $el.offset();
 
            tt.empty()
                .append(ttCon.html(text))
                .appendTo("body");
 
            //Calculate after append
            var bWidth  = tt.width() > $el.width() ? tt.width() :  $el.width(),
                lWidth  = tt.width() < $el.width() ? tt.width() :  $el.width(),
                dWidth  = bWidth - lWidth,
                topVal  = (offset.top - tt.height()) - 8,
                leftVal = (offset.left - (dWidth / 2));
 
            tt.css({
                top:topVal,
                left:leftVal
            }).fadeIn("fast");
        }
    },
    mouseleaveEvent: function(e){
        $('.tooltipOuter.temp').remove();
    }
}
 
});